var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkHoursIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 4H16.0003C15.267 4 14.667 4.6 14.667 5.33333V7.48L14.6803 7.49333L21.347 13.4933C22.187 14.24 22.667 15.3333 22.667 16.4667V17.3333H25.3337V20H22.667V22.6667H25.3337V25.3333H22.667V28H26.667C27.4003 28 28.0003 27.4 28.0003 26.6667V5.33333C28.0003 4.6 27.4003 4 26.667 4ZM20.0003 9.33333H17.3337V6.66667H20.0003V9.33333ZM25.3337 14.6667H22.667V12H25.3337V14.6667ZM25.3337 9.33333H22.667V6.66667H25.3337V9.33333Z",
    fill: "#17255A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 26.6668V16.4668C19.9996 16.2807 19.9603 16.0968 19.8845 15.9269C19.8087 15.7569 19.6982 15.6047 19.5601 15.4801L12.8934 9.48008C12.6518 9.25322 12.3315 9.12895 12.0001 9.13342C11.6801 9.13342 11.3601 9.25342 11.1068 9.48008L4.44008 15.4801C4.29995 15.6031 4.18808 15.755 4.11213 15.9253C4.03618 16.0956 3.99796 16.2803 4.00008 16.4668V26.6668C4.00008 27.4001 4.60008 28.0001 5.33342 28.0001H8.00008C8.73342 28.0001 9.33342 27.4001 9.33342 26.6668V21.3334H14.6668V26.6668C14.6668 27.4001 15.2668 28.0001 16.0001 28.0001H18.6668C19.4001 28.0001 20.0001 27.4001 20.0001 26.6668Z",
    fill: "#17255A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkHoursIcon);
export default __webpack_public_path__ + "static/media/workHoursIcon.d9662467244beb6b66a2b898e79a25c3.svg";
export { ForwardRef as ReactComponent };